import React from "react";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import ProgressBar from "../utils/ProgressBar";

import type { JSX } from "react";

import type { PercentageItem } from "../utils/ProgressBar";

interface ObjectiveComponentProps {
  title: string;
  subTitle?: string;
  completion?: PercentageItem[];
  unit?: string;
  current?: number;
  objective?: number;
  borderColor?: string;
}

function toHoursAndMinutes(totalSeconds: number): string {
  const totalMinutes = Math.floor(totalSeconds / 60);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (minutes === 0) {
    return `${hours}h`;
  }

  return `${hours}h ${minutes}m`;
}

function ObjectiveComponent({
  title,
  subTitle,
  current = 0,
  objective = 0,
  unit = "day",
  completion = [{ value: 0 }],
  borderColor,
}: ObjectiveComponentProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const containerClassName = classNames(
    "flex flex-1 flex-col gap-[0.46875rem] rounded-[0.3125rem] bg-card p-[0.78125rem]",
    borderColor ? "border-2" : "border",
    { "border-input": !borderColor },
  );

  return (
    <div
      className={containerClassName}
      style={{
        borderColor,
      }}
    >
      <div className="flex flex-col gap-[0.15625rem]">
        <div className="flex justify-between gap-[0.15625rem]">
          <span className="font-medium">{title}</span>
          <span className="font-medium">{subTitle}</span>
        </div>
        <div className="flex justify-between">
          <span>
            {t("current")}: {toHoursAndMinutes(current)} /{" "}
            <span className="lowercase">{t(unit)}</span>
          </span>
          <span>
            {t("objective")}: {toHoursAndMinutes(objective)} /{" "}
            <span className="lowercase">{t(unit)}</span>
          </span>
        </div>
      </div>
      <ProgressBar percentageList={completion} />
    </div>
  );
}

export default ObjectiveComponent;
